import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SelectItem } from 'primeng/primeng';

import { environment } from '../../../environments/environment';
import {StrtObjective} from '../../shared/models/plan/StrtObjective';


@Injectable()
export class ObjectiveService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getObjectiveSelectItems(objectives: StrtObjective[]): SelectItem[] {
      return objectives.map(objective => <SelectItem>{label: objective.text, value: objective.objectiveId});
  }

  getObjectives(strategyId: number, priorityId: number): Observable<StrtObjective[]> {
    return this.http.get<StrtObjective[]>(`${this.baseUrl}/strategies/${strategyId}/priorities/${priorityId}/objectives`);
  }

  createObjective(objective: StrtObjective): Observable<StrtObjective> {
    return this.http.post<StrtObjective>(
      `${this.baseUrl}/strategies/${objective.strategyId}/priorities/${objective.priorityId}/objectives`, objective);
  }

  updateObjective(objective: StrtObjective): Observable<StrtObjective> {
    return this.http.put<StrtObjective>(
      `${this.baseUrl}/strategies/${objective.strategyId}/priorities/${objective.priorityId}/objectives/${objective.objectiveId}`,
      objective);
  }

  deleteObjective(objective: StrtObjective): Observable<{}> {
    return this.http.delete<{}>(
      `${this.baseUrl}/strategies/${objective.strategyId}/priorities/${objective.priorityId}/objectives/${objective.objectiveId}`);
  }
}
